module.exports = __webpack_public_path__ + "static/img/kd.98085ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homePage/kd.jpg
// module id = Eaxx
// module chunks = 1